import React from "react";
import ReactDOM from "react-dom";

import Site from "./Site";

import "./layout.css";

function render(containerId: string) {
  ReactDOM.render(
    <React.StrictMode>
      <Site />
    </React.StrictMode>,
    document.getElementById(containerId)
  );
}

// Expose the render function
(window as any).LiveSite = {
  render: render
};

// Optionally, still allow normal rendering when running standalone
if (document.getElementById('funnel')) {
  render('funnel');
}